import { EnumDefinition } from "./EnumDefinition"

/**
 * Enumerado con los distintos tipos de acciones que pueden realizar los botones del header
 */
export class TiposAccionBoton 
{
    static undefined = new EnumDefinition(0, "", "");
    static Notario = new EnumDefinition(1, "about", "Palabras del Notario", "Notarios", "Notarios") ;
    static Servicios = new EnumDefinition(2, "service", "Servicios", "Servicios", "Servicios");
    static Blog = new EnumDefinition(3, "blog", "Blog","Blog","Blog");
    static Testimonial = new EnumDefinition(4, "testimonial", "Testimonios","Testimonios", "Testimonios");
    static Gallery = new EnumDefinition(5, "homegallery", "Galería","Gallery","Gallery");  
    static Contacto = new EnumDefinition(6,"contact", "Contactar", "Contactar","Contacto");
    static Inicio = new EnumDefinition(7, "Inicio", "Inicio","Inicio","Inicio");
    static NV = new EnumDefinition(8, "NV", "Notaría Virtual","Notaría Virtual","Notaría Virtual");  
    static Equipo = new EnumDefinition(9, "equipo", "Equipo","Equipo","equipo");  
    static Chatbot = new EnumDefinition(10, "chatbot", "Asistente Virtual IA", "Chatbot", "Chatbot");
}